import * as _ from "lodash";

export class AddressSearch {
  constructor() {
      this.addresses = [];
  }

  addresses: Array<SearchAddress>;
}

export class SearchAddress {
  constructor() {
    this.populated = false;
    this.addressLine = '';
    this.formattedAddress = new FormattedAddress();
    this.structuredAddress = new StructuredAddress();
  }

  id?: string;
  populated: boolean;
  addressLine: string;
  formattedAddress: FormattedAddress;
  structuredAddress: StructuredAddress;
}

export class FormattedAddress {
  constructor() {
    this.line1 = '';
    this.line2 = '';
    this.line3 = '';
    this.suburb = '';
    this.state = '';
    this.postcode = '';
    this.country = '';
  }

  dpid?: string;
  line1: string;
  line2: string;
  line3: string;
  suburb: string;
  state: string;
  postcode: string;
  country: string;

  public getAddressLine(): string {
    let result = '';
    result = this.appendValue(result, this.line1, "");
    result = this.appendValue(result, this.line2, ", ");
    result = this.appendValue(result, this.line3, ", ");
    result = this.appendValue(result, this.suburb, ", ");
    result = this.appendValue(result, this.state, " ");
    result = this.appendValue(result, this.postcode, " ");
    result = this.appendValue(result, this.country, ", ");

    return result;
  }

  private appendValue(existingValue: string, value: string, prefix: string): string
  {
    let result = existingValue;

    if (!_.isNil(value) && value !== '') {
      if (!_.isNil(result) && result !== '') {
        result += prefix;
      }

      result += value;
    }

    return result;
  }
}

export class StructuredAddress {
}
